export function normalizeUrl(path) {
    return path.replace(/([^:]\/)\/+/g, '$1')
}

export function replaceUrlParams(path, replaces) {
    if (typeof replaces !== 'object' || Object.keys(replaces).length === 0) {
        return path
    }

    Object.keys(replaces).forEach(key => {
        path = path.replace(`:${ key }`, replaces[key])
    })

    return path
}

export function getApiUrl(path, replaces) {
    if (replaces) {
        path = replaceUrlParams(path, replaces)
    }

    return normalizeUrl(process.env.VUE_APP_BASE_API_URL + '/' + path)
}
